module.exports = __webpack_public_path__ + "img/logo.8c2798a7.png";